import { type InputRule, markTypeInputRule } from "@handlewithcare/prosemirror-inputrules";
import { type MarkType } from "prosemirror-model";

export const kbdRule = (markType: MarkType): InputRule => {
	return markTypeInputRule(/kbd`(?<content>[^`]+)`/d, markType);
};
